exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\npre[data-v-d3a2de94] {\r\n  text-align: start;\n}\r\n", ""]);

// exports
